
<one-table>
    <one-table-content>
        <mat-table [dataSource]="dataSource"Sort mat multiTemplateDataRows >
            <ng-container matColumnDef="reminderDate">
            <mat-header-cell *matHeaderCellDef style="max-width: 140px;">Date</mat-header-cell>
            <mat-cell *matCellDef="let element" style="max-width: 140px;"><div class="truncate-text" >{{ element.reminderDate }}</div></mat-cell>
            </ng-container>

            <ng-container matColumnDef="reminderSubject">
            <mat-header-cell *matHeaderCellDef  style="max-width: 300px;">Subject</mat-header-cell>
            <mat-cell *matCellDef="let element" style="max-width: 300px;"><div class="truncate-text">{{ element.reminderSubject }}</div>           
            </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="reminderMessage">
            <mat-header-cell *matHeaderCellDef>Message</mat-header-cell>
            <mat-cell *matCellDef="let element"><div class="truncate-text" [innerHTML]="element.reminderMessage"></div></mat-cell>
            </ng-container>

            <ng-container matColumnDef="reminderSendMode">
            <mat-header-cell *matHeaderCellDef style="max-width: 250px;">Send mode</mat-header-cell>
            <mat-cell style="max-width: 250px;" *matCellDef="let element; let inx = dataIndex" ><div class="example-button-row">Automatic</div></mat-cell>
            </ng-container>

            <ng-container matColumnDef="reminderActionIcons">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element; let indx = dataIndex" >
                    <button 
                        mat-icon-button 
                        one-icon-button 
                        matSuffix 
                        [disabled]="!isReminderEditable(element)"
                        [class.disabled-button]="!isReminderEditable(element)"
                        (click)="editReminderTemplate(element, indx)"
                        [matTooltip]="!isReminderEditable(element) ? 'Cannot edit reminders scheduled for today or in the past' : 'Edit reminder'">
                        <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="delete-icon">edit</mat-icon>
                    </button>
                    <button 
                        mat-icon-button 
                        one-icon-button 
                        matSuffix 
                        [disabled]="!isReminderRemovable(element)"
                        [class.disabled-button]="!isReminderRemovable(element)"
                        (click)="deleteReminderTemplate(element, indx)"
                        [matTooltip]="!isReminderRemovable(element) ? 'Cannot delete reminders scheduled for today or in the past' : 'Delete reminder'">
                        <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix class="delete-icon">delete</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>
            
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row
            *matRowDef="let row; columns: displayedColumns"
            [ngClass]="{ checked: selection.isSelected(row), disabled: row.disabled }"
            class="one-element-row"
            ></mat-row>
        </mat-table>
    </one-table-content>
</one-table>
  
  